import * as React from 'react';
import { UIText3 } from '@cian/ui-kit';
import { IconProductTrust16 } from '@cian/ui-kit-design-tokens/icons';

import * as style from './style.css';

export const PremiumBuilderLabel: React.FC = () => {
  return (
    <div className={style['label']}>
      <IconProductTrust16 color="icon-main-default" />
      <UIText3 color="text-primary-default">Надежный застройщик</UIText3>
    </div>
  );
};
